import { useNavigate } from "react-router"
import { useEffect } from "react"

export function Redirect({ to, replace = true, state }) {
    const navigate = useNavigate()
    useEffect(() => {
        if (!to) return
        if (/^https?:\/\//i.test(to)) {
            window.location.href = to
            return
        }
        navigate(to, { replace, state })
    }, [to, replace, state, navigate])
    return null
}
